import script from "./AddFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFilter.vue?vue&type=script&setup=true&lang=js"

import "./AddFilter.vue?vue&type=style&index=0&id=52807d06&lang=scss"

const __exports__ = script;

export default __exports__